/**
 * 페이징 줄 — "이전  1 … 3 [4] 5 … 18  다음  N–M / total건". 목록 한 묶음(rows · total · limit · offset)을 받는 화면이 같이 쓴다
 * (제품 목록 2026-10-14 → 재고 현황 · 요청함). 버튼 전부 같은 data-action 에 data-offset(그 쪽의 offset) — 핸들러 하나가 offset 을 옮기고 다시 받는다.
 */

/** 한 묶음의 자리 — rows 는 안 본다 */
export interface PageSlice { total: number; limit: number; offset: number }

/** 현재 쪽 양옆으로 보이는 번호 수 — 1 … 3 [4] 5 6 … 18 */
const PAGE_WINDOW = 2;

/**
 * 이전 · 번호들 · 다음. 전부 data-action=goAction 에 data-offset(그 쪽의 offset).
 * 번호는 현재 ±PAGE_WINDOW 와 처음 · 끝, 빈 자리는 "…". 현재 쪽은 disabled. total 0 이면 "0건" 만.
 */
export function renderPagerLine(page: PageSlice, goAction: string): string {
  if (page.total === 0) return '<span class="pc-count">0건</span>';
  const from = page.offset + 1;
  const to = Math.min(page.offset + page.limit, page.total);
  const current = Math.floor(page.offset / page.limit) + 1;
  const last = Math.ceil(page.total / page.limit);
  const numbers = pageNumbersOf(current, last).map((n) => n === null
    ? '<span class="pager-gap">…</span>'
    : `<button type="button" class="btn-ghost pager-no${n === current ? ' is-current' : ''}" data-action="${goAction}" data-offset="${(n - 1) * page.limit}" ${n === current ? 'disabled' : ''}>${n}</button>`,
  ).join('');
  return `
    <span class="pager-line">
      <button type="button" class="btn-ghost" data-action="${goAction}" data-offset="${Math.max(0, page.offset - page.limit)}" ${current > 1 ? '' : 'disabled'}>이전</button>
      ${numbers}
      <button type="button" class="btn-ghost" data-action="${goAction}" data-offset="${page.offset + page.limit}" ${current < last ? '' : 'disabled'}>다음</button>
      <span class="pc-count">${from.toLocaleString()}–${to.toLocaleString()} / ${page.total.toLocaleString()}건</span>
    </span>`;
}

/** 보일 쪽 번호 — null 은 "…" 자리. 1 과 last 는 늘, 그 사이는 current ±PAGE_WINDOW 만 */
export function pageNumbersOf(current: number, last: number): (number | null)[] {
  const out: (number | null)[] = [];
  for (let n = 1; n <= last; n++) {
    const bShown = n === 1 || n === last || Math.abs(n - current) <= PAGE_WINDOW;
    if (bShown) { out.push(n); continue; }
    if (out[out.length - 1] !== null) out.push(null);
  }
  return out;
}
